import { omrehBaseClient } from "./client";

const GetAgeTypeArabianDropDown=()=>{
   return omrehBaseClient
       .get("/StaticVariables/GetAgeTypeArabianDropDown"); 
}
const GetDegreeOfRelativityDropDown=()=>{
    return omrehBaseClient
        .get("/StaticVariables/GetDegreeOfRelativityDropDown");
}

const GetOperationDropDown=()=>{
    return omrehBaseClient
        .get("/StaticVariables/GetOperationDropDown");
}

const GetTitleGuestServicesDropDown = (status) => {
  return omrehBaseClient
    .get("/StaticVariables/GetTitleGuestServicesDropDown", {
      params: {
        'status': status
      }
    });
}

const GetGuestServicesDropDown = () => {
  return omrehBaseClient
    .get("/StaticVariables/GetGuestServicesDropDown");
}

const GetGuestServiceTypeDropDown = (status) => {
  return omrehBaseClient
    .get("/StaticVariables/GetGuestServiceTypeDropDown", {
      params: {
        'status': status
      }
    });
}

const GetArabiaCityDropDown = () => {
  return omrehBaseClient
    .get("/StaticVariables/GetArabiaCityDropDown");
}


const GetMainCityDropDown = () => {
  return omrehBaseClient
    .get("/StaticVariables/GetMainCityDropDown");
}


const staticVariablesApi = {
    GetAgeTypeArabianDropDown, GetDegreeOfRelativityDropDown, GetOperationDropDown, GetTitleGuestServicesDropDown, GetGuestServiceTypeDropDown,
    GetArabiaCityDropDown, GetMainCityDropDown, GetGuestServicesDropDown
}

export default staticVariablesApi